/* eslint-disable react/prop-types */

import { forwardRef } from 'react';
import { ButtonProps } from '../types';
import { StyledButton } from '../styles';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    children,
    variant = 'contained',
    size = 'medium',
    color = 'primary',
    fullWidth = false,
    disabled = false,
    className,
    loading = false,
    loadingPosition = 'center',
    startIcon,
    endIcon,
    ...rest
  } = props;

  return (
    <StyledButton
      role="button"
      ref={ref}
      variant={variant}
      size={size}
      color={color}
      fullWidth={fullWidth}
      disabled={disabled}
      className={className}
      loading={loading}
      loadingPosition={loadingPosition}
      startIcon={startIcon}
      endIcon={endIcon}
      {...rest}
    >
      {children}
    </StyledButton>
  );
});

Button.displayName = 'Button';
